import React, { useState, useEffect } from "react";
import { compose } from "recompose";
import withTranslator from "../Translator/withTranslation";
import additionalfn from "../../_additionalfn";
import styled from "@emotion/styled";
import moment from "moment";

const CloseButton = styled.div`
    font-size:2em;
    margin-left:1em!important;
    cursor: pointer;
`;

const SaturdayArrivalBannerComponent = (props) => {
    const [dismissed, setDismissed] = useState(false);
    const [isShowing, setIsShowing] = useState(false);

    useEffect( () => { 
        //const isDismissed = additionalfn.getCookie('cv_cs_pp') ? true : false;
        setDismissed(dismissed);
        setIsShowing(saturdayArrival(props.query));
    },[props.query])

    const dismiss = () => {
        setDismissed(true);
       // additionalfn.setCookie('cv_cs_pp', true, 1);   
    }

    const saturdayArrival = (query) => {
        const params = additionalfn.tokenize(query);
        if (params.stayStart && params.stayEnd ) {
            var start = moment(params.stayStart, "DD-MM-YYYY");
            var end = moment(params.stayEnd, "DD-MM-YYYY");
            if (start.day() !== 6 || end.diff(start, 'days') < 7 ) {
                return true;
            }
        }
        return false;
    }

    return ( 
        !dismissed && isShowing &&  <div className="alert alert-default mar-no bor-rad-no flex justify-center items-center p-2 p-md-3 font-w600 font-120">
            <div className="p-1 p-md-2" dangerouslySetInnerHTML={{ __html:  props.t('most_availability_with_arrival_on_saturday') }}></div>
            <CloseButton onClick={() => dismiss()} className="line-height-inherit btn-no mar-no pad-no bor-no bg-no">×</CloseButton>
        </div>
    )
}

export const SaturdayArrivalBanner = compose(
    withTranslator
)
(SaturdayArrivalBannerComponent);